/** 跟随链接文字颜色的 Telegram 标志 */
export function TelegramIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className="inline-block h-[18px] w-[18px] shrink-0 align-middle"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M21.4 3.2 18.1 20c-.1.6-.5.8-1 .5l-5-3.7-2.4 2.3c-.3.3-.5.5-1 .5l.4-5.1L18.4 6c.4-.4-.1-.6-.6-.3L6.3 13l-4.9-1.5c-.6-.2-.6-.6.1-.9L20.6 3c.5-.2.9 0 .8.2Z" />
    </svg>
  )
}
